import React, { useCallback } from 'react';
import { Container, Row } from 'reactstrap';
import classNames from 'classnames';
import { When } from 'react-if';
import './styles.css';
import { useNavigate } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import SignInBody from '../../components/elements/customModals/SignInModalForm/SignInBody';
import { IS_SIDEKICK_APP } from '../../constants/projects';
import { ReactComponent as LinkedInIcon } from './linkedin_auth.svg';
import { useAuth } from '../../hooks/useAuth';

const SignInPage = () => {
    const navigate = useNavigate();

    const { authLoading, setAuthLoading } = useAuth();

    const params = new URL(window.location).searchParams;

    const redirectLink = params.get('redirect_to');

    const handleRedirectToSignUp = useCallback(() => {
        navigate(ROUTES.SIGN_UP);
    }, [navigate]);

    const handleRedirectToForgotPassword = useCallback(() => {
        navigate(ROUTES.RESET_PASSWORD);
    }, []);

    const handleLinkedInAuth = useCallback(() => {
        window.open('popup.html', 'name', 'height=585,width=400');
    }, []);

    return (
        <div
            className={classNames('unauthorized-sign-in__container', {
                'unauthorized-sign-in__container--sidekick': IS_SIDEKICK_APP,
            })}
        >
            <Container>
                <Row className="unauthorized-sign-in">
                    <div className="unauthorized-sign-in__popup">
                        <h5 className="unauthorized-sign-in__popup-title">
                            {IS_SIDEKICK_APP ? 'Sign in to your Sidekick Network' : 'Sign-In'}
                        </h5>
                        <When condition={IS_SIDEKICK_APP}>
                            <div
                                className="unauthorized-sign-in__linkedin d-flex align-items-center"
                                onClick={handleLinkedInAuth}
                            >
                                <div className="flex">
                                    <LinkedInIcon />
                                </div>
                                <div>Sign in with Linkedin</div>
                                <div className="flex" />
                            </div>
                        </When>
                        <SignInBody
                            redirectToSignUp={handleRedirectToSignUp}
                            redirectToForgotPassword={handleRedirectToForgotPassword}
                            authLoading={authLoading}
                            setAuthLoading={setAuthLoading}
                            redirectLink={redirectLink}
                        />
                    </div>
                </Row>
            </Container>
        </div>
    );
};

SignInPage.propTypes = {};

export default React.memo(SignInPage);
